import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Play } from 'lucide-react';
import SocialPlatforms from './SocialPlatforms';
import StreamingPlatforms from './StreamingPlatforms';
import usePreviewBackground from './usePreviewBackground';

export default function LinkPreviewModernLayout({ previewData }) {
    const {
        background,
        release,
        player,
        socialPlatforms,
        streamingPlatforms,
        mode
    } = previewData;
    const bg = usePreviewBackground(background, release);

    return (
        <div className="device-wrapper w-full relative bg-cover bg-center rounded-[36px] border-8 border-[#B2B2B2] overflow-hidden"
            style={{ background: bg.background }}
        >
            {/* Blur Background Layer */}
            {bg.blur && (
                <div
                    className="absolute inset-0 scale-125 blur-3xl"
                    style={{
                        backgroundImage: `url(${release.image})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center"
                    }}
                />
            )}

            {/* Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/70 to-black/50"></div>

            {/* Notch */}
            <div className="absolute top-[10px] left-1/2 transform -translate-x-1/2 bg-black h-6 w-24 border border-light rounded-full z-10"></div>

            {/* Screen Content */}
            <div className="relative pt-12 pb-4 px-8">

                <div className="content-wrapper mb-6">
                    {/* Video Player Area */}
                    {/* <div className="top-section relative w-full aspect-video bg-cover bg-center overflow-hidden shadow-lg min-h-40"
                        style={{ backgroundImage: `url(${release.image})` }}

                    >
                        <div className="absolute inset-0 flex items-center justify-center">
                            <button className="bg-white/20 backdrop-blur-md hover:bg-white/30 rounded-full p-4 transition-all duration-300 transform hover:scale-110">
                                <Play className="w-8 h-8 text-white fill-white" />
                            </button>
                        </div>
                        <div className="absolute top-0 left-0 w-32 h-32 bg-blue-300 rounded-full blur-3xl opacity-30"></div>
                    </div> */}
                    <div className="flex justify-center mb-6">
                        <div
                            className="relative w-[160px] h-[160px] bg-cover bg-center rounded-md shadow-xl"
                            style={{ backgroundImage: `url(${release.image})` }}
                        >
                            <div className="absolute inset-0 flex items-center justify-center">
                                <button className="bg-black/40 backdrop-blur-sm hover:bg-black/60 rounded-full p-3 transition-all duration-300">
                                    <Play className="w-6 h-6 text-white fill-white" />
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Title and Track Section */}
                    {/* <div className="text-center my-4">
                        <h2 className="text-white text-base font-bold mb-1">{release.name || 'Track Name'}</h2>
                        <p className="text-gray-300 text-sm m-0">Listen to my new track {release.name}</p>
                    </div> */}
                    <div className="text-center mb-6">
                        <h2 className="text-white text-3xl font-bold mb-2">
                            {release.name || "Track Name"}
                        </h2>

                        <p className="text-gray-300 text-sm">
                            {mode === "presave"
                                ? release.subtitle
                                : (release.subtitle || `Check out my release: ${release.name || ""}`)}
                        </p>
                    </div>

                    {/* Modern Layout */}
                    <div className="list-wrapper max-h-[250px] space-y-2 overflow-auto">
                        <StreamingPlatforms
                            platforms={streamingPlatforms}
                            variant="modern"
                             mode={mode}
                        />
                    </div>
                </div>

                {/* Social Media Icons */}
                <div className="social-wrapper text-center mb-4">
                    <div className="text-sm text-white font-semibold mb-2">Follow on:</div>
                    <SocialPlatforms
                        platforms={socialPlatforms}
                        variant="modern"
                    />
                </div>

                {/* Footer Text */}
                <div className="text-center mb-4">
                    <p className="text-gray-300 text-xs leading-relaxed">
                        By using this site you agree to our <Link to={'/terms-of-service'} className="text-white font-bold">Terms of Use</Link> and <Link to={'/privacy-policy'} className="text-white font-bold">Privacy Policy</Link>
                    </p>
                </div>

                {/* Copyright */}
                <div className="text-center">
                    <p className="text-gray-300 text-xs">Copyright © 2026</p>
                </div>
            </div>
        </div>
    );
}